import TimeGridLoading from './time-grid-loading.component';
import { ScheduleTimeGrid } from './schedule-time-grid.component';
import { WhatsappTabContent } from './whatsapp-tab-content.component';
import { StandaloneTabContent } from './standalone-tab-content.component';

import { SecondaryTabsContent } from '@/components/ui/secondary-tab.component';
import { ScheduleType, SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { TabItem, TabsType } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-schedule-tab.hook';
import { useTimeSlots } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-time-slot.hook';

interface ContentTabProps {
  tabs: TabItem[];
  schedule: SearchPartnerData;
  procedureName: string;
  selectedTab: TabsType;
  onChangeContentToStandalone(value: boolean): void;
}

export function ScheduleContentTab({
  tabs,
  schedule,
  procedureName,
  selectedTab,
  onChangeContentToStandalone,
}: ContentTabProps) {
  const {
    isFirstTabLoading,
    scheduleSlots,
    fetchNewSlots,
    arrivalOrder,
    laboratorial,
    hasEndedSchedulesSlots,
    hasEndedArrivalOrder,
    hasEndedLaboratorialSlots,
  } = useTimeSlots({
    selectedTab,
    schedule,
  });
  const tabsKeys = tabs?.map((tab) => tab.key) || [];
  const scheduleTabs = [
    {
      key: TabsType.SCHEDULED,
      scheduleType: ScheduleType.SCHEDULED,
      slots: scheduleSlots,
      hasEnded: hasEndedSchedulesSlots,
    },
    {
      key: TabsType.ARRIVAL_ORDER,
      scheduleType: ScheduleType.ARRIVAL_ORDER,
      slots: arrivalOrder,
      hasEnded: hasEndedArrivalOrder,
    },
    {
      key: TabsType.LABORATORIAL,
      scheduleType: ScheduleType.LABORATORIAL,
      slots: laboratorial,
      hasEnded: hasEndedLaboratorialSlots,
    },
  ];

  return (
    <>
      {scheduleTabs.map(
        ({ key, scheduleType, slots, hasEnded }) =>
          tabsKeys.includes(key) && (
            <SecondaryTabsContent key={key} value={key}>
              {isFirstTabLoading
                ? (
                    <TimeGridLoading scheduleType={scheduleType} />
                  )
                : (
                    <ScheduleTimeGrid
                      slots={slots}
                      scheduleType={scheduleType}
                      fetchNewSlots={fetchNewSlots}
                      hasEnded={hasEnded}
                    />
                  )}
            </SecondaryTabsContent>
          ),
      )}

      {(tabsKeys.includes(TabsType.FLEX) || tabsKeys.includes(TabsType.WHATSAPP)) && (
        <SecondaryTabsContent
          value={tabsKeys.includes(TabsType.WHATSAPP) ? TabsType.WHATSAPP : TabsType.FLEX}
          className="h-full"
        >
          <WhatsappTabContent procedure={procedureName} schedule={schedule} withTitle={false} />
        </SecondaryTabsContent>
      )}

      {tabsKeys.includes(TabsType.STANDALONE) && (
        <SecondaryTabsContent value={TabsType.STANDALONE} className="h-fit">
          <StandaloneTabContent withTitle={false} onChangeContentToStandalone={onChangeContentToStandalone} />
        </SecondaryTabsContent>
      )}
    </>
  );
}
